<template>
  <div class="ui-filter-range">
    <label class="xs-title">{{ $attrs.name }}</label>
    <div class="inputs">
      <input v-model.number="minValue" placeholder="Start" type="number" @change="setMin" />
      <div>—</div>
      <input v-model.number="maxValue" placeholder="End" type="number" @change="setMax" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    min: {
      type: Number,
      default() {
        return 0
      }
    },
    max: {
      type: Number,
      default() {
        return 2000
      }
    }
  },
  data() {
    return {
      minValue: '',
      maxValue: ''
    }
  },
  methods: {
    setMax() {
      if (this.maxValue > this.max) {
        this.maxValue = this.max
      } else if (this.maxValue < this.min) {
        this.maxValue = this.min
      }
    },
    setMin() {
      if (this.minValue > this.max) {
        this.minValue = this.max
      } else if (this.minValue < this.min) {
        this.minValue = this.min
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-filter-range {
}
label {
  margin-bottom: 0.8em;
}
.inputs {
  display: flex;
  align-items: center;
  div {
    margin: 0 0.5em;
    opacity: 0.5;
  }
}
</style>
